module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel-cell-essence.ab287d37.png";